/*
 * validateExists creates the window.validateExists function.
 *
 * window.validateExists checks if the jQuery validator plugin can be and is active.
 * This is used for discontinueing a script that uses jQuery validator.
 * The script is discontinued to avoid errors which may cause the JS to break in older browsers.
 */
const validateExists = () => {
  const form = $('form');

  if (form.length > 0) {
    return $.data(form[0], 'validator') !== undefined;
  }
  return false;
};

export default validateExists;
